import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { SimulationStore, SimulationState } from './simulation.store';

@Injectable({ providedIn: 'root' })
export class SimulationQuery extends QueryEntity<SimulationState> {

  isLoading$ = this.selectLoading();
  active$ = this.selectActive();
  simulations$ = this.selectAll();

  coverageMode$ = this.select('coverageMode');

  parametersErrors$ = this.select('parametersErrors');

  constructor(protected store: SimulationStore) {
    super(store);
  }

}
